import events from '../events/events';
import Overlay from '../overlay/overlay';
import breakpoint from '../breakpoint/breakpoint';

let overlay;
events.on('main.inited', () => {
    const parent = document.getElementById('body-content');
    overlay = new Overlay(parent, 'overlay_body-content');

    if (!window.getNotificationCount) {
        const notificationBadgeNew = document.querySelectorAll('[data-notification-count]');
        const notificationBtn = document.querySelector('[data-notification-btn]');
        
        
        function setBadgeNotification(count) {
            if (notificationBadgeNew.length && count != null) {
                count = +count;
                if (count) {
                    notificationBadgeNew.forEach((node) => {
                        node.innerHTML = count;
                    });
                }
            }
       }

        function getNotificationCount() {
            if (notificationBtn) {
                $.get(notificationBtn.getAttribute('href'), {'new': true}).done((count) => {
                    setBadgeNotification(count);
                });
            }
        }

        getNotificationCount();
        setInterval(() => getNotificationCount(), 30000);
    }

    document.querySelectorAll('.header-search__input').forEach((inputEl) => {
        inputEl.addEventListener('change', function() {
            document.querySelectorAll('[data-hidden-search]').forEach((hiddenInput) => {
                hiddenInput.value = this.value;
            });
        });
    });
});

function recalcMargin(container) {
    const style = window.getComputedStyle ? getComputedStyle(container, null) : container.currentStyle;
    const curMarginRight = parseInt(style.marginRight) || 0;
    const box = container.getBoundingClientRect();
    const marginRight = `${box.right + curMarginRight - document.body.clientWidth}px`;
    container.style.marginRight = marginRight;
}

events.on('dropdown.toggle', (el, dropdown, isVisible) => {
    if (dropdown === 'header-extended-search') {
        if (isVisible) {
            overlay.show();
        } else {
            overlay.hide()
        }

        const container = el.closest('.header-search_xl');
        if (container) {
            container.classList.toggle('header-search_wide', isVisible);
            if (isVisible && breakpoint.name === 'xl') {
                recalcMargin(container);
            } else {
                container.style.marginRight = null;
            }
        }

        if (isVisible) {
            const filterBlock = document.querySelector('[data-load-filter]');
            if (filterBlock && !filterBlock.dataset.loaded) {
                filterBlock.dataset.loaded = 'true';
                $.get(filterBlock.dataset.url, function(data) {
                    $(filterBlock).html(data);
                });
            }
        }
    }
});

events.on('breakpoint.change', function(current) {
    if (current.name == 'xl') {
        document.querySelectorAll('.header-search_wide').forEach((container) => {
            recalcMargin(container);
        });
    } else {
        document.querySelectorAll('.header-search_wide').forEach((container) => {
            container.style.marginRight = null;
        });
    }
});